import { apiClient } from './apiClient';
import type { ImpersonationUser } from '../auth/permissions.types';

export const impersonationApi = {
  canImpersonate: async (): Promise<boolean> => {
    const response = await apiClient.get<boolean>('/impersonation/can-impersonate');
    return response.data;
  },

  getUsers: async (): Promise<ImpersonationUser[]> => {
    const response = await apiClient.get<ImpersonationUser[]>('/impersonation/users');
    return response.data;
  },
};

export default impersonationApi;
